<template>
  <div ref="container_3">
    <div v-if="value.contactUserName"
      class="contact_1 hover-shadow">
      <span>{{ value.contactUserName }}({{ value.contactUserPhone }})</span>
      <i @click="onClick"
        style="float:right;padding-top:10px;"
        class="el-icon-arrow-down"></i>
    </div>

    <div v-if="!value.contactUserName"
      class="contact_1 hover-shadow">
      <span style="color:#c7c7c7;">工单联系人</span>
      <i @click="onClick"
        style="float:right;padding-top:10px;cursor:pointer;"
        class="el-icon-arrow-down"></i>
    </div>

    <el-dialog
      title="修改联系人"
      top="0"
      :modal="false"
      class="dialog_1"
      :visible.sync="dialogVisible"
      width="600px">

      <el-form style="padding:0 15px;">
        <el-form-item label="姓名">
          <el-input v-model="contactUserName"/>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="contactUserPhone"/>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    name : 'TicketContactUser',

    props : ['value'],

    data() {
      return {
        dialogVisible : false,
        contactUserName : null,
        contactUserPhone : null,
      }
    },

    watch : {
      value() {
        this.contactUserName = this.value.contactUserName;
        this.contactUserPhone = this.value.contactUserPhone;
      }
    },

    mounted() {
      this.contactUserName = this.value.contactUserName;
      this.contactUserPhone = this.value.contactUserPhone;
    },

    methods : {
      onSubmit() {
        var _e = Object.assign({}, this.value, { contactUserName : this.contactUserName, contactUserPhone : this.contactUserPhone });
        this.$emit('change', _e);

        this.dialogVisible = false;
      },

      onClick() {
        this.dialogVisible = true;

        var rect = this.$refs.container_3.getBoundingClientRect();
        $('.dialog_1 .el-dialog').css({
          "position" : "absolute",
          "left" : rect.x + "px",
          "top" : rect.bottom + "px"
        });
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketContactUser.vue